import WidgetsContainer from '@components/PlayerWidgets/WidgetsContainer';
import { $editingImageMarker } from '@stores/editingMarkerStores';
import {
  $playerWidgets,
  $playerWidgetsApi,
  type PlayerWidgetType,
} from '@stores/playerWidgets';
import { useStore } from 'effector-react';
import { useEffect } from 'react';
import { BatchPreviewWidget } from '../components/BatchPreviewWidget';
import TitleWidget from './TitleWidget';

function ImageMarkerWidgets() {
  const editing = useStore($editingImageMarker);
  const widgets = useStore($playerWidgets);

  useEffect(() => {
    return $playerWidgetsApi.clear;
  }, []);

  if (!editing) return null;

  const renderWidget = (type: PlayerWidgetType) => {
    if (type === 'batchPreview') {
      return (
        <BatchPreviewWidget
          reversed
          data={editing.marker}
          isActive={!!editing.isActive}
          key="batchPreview"
        />
      );
    }
    if (type === 'title') return <TitleWidget key="title" />;
  };
  return <WidgetsContainer>{widgets.map(renderWidget)}</WidgetsContainer>;
}

export default ImageMarkerWidgets;
